export const SIDEBAR_COOKIE_NAME = 'sidebar_state';
export const SIDEBAR_COOKIE_MAX_AGE = 60 * 60 * 24 * 7;
export const SIDEBAR_WIDTH = '16rem';
export const SIDEBAR_WIDTH_MOBILE = '18rem';
export const SIDEBAR_WIDTH_ICON = '3rem';
export const SIDEBAR_KEYBOARD_SHORTCUT = 'b';
// Viewport width below which the global nav auto-collapses into the mobile
// drawer. Tailwind's `lg` (1024px) — the desktop/tablet boundary — so the nav
// stays expanded at normal desktop/laptop widths and only collapses on
// genuinely narrow tablet-portrait / mobile screens. MUST stay in sync with
// the `lg:` responsive classes in sidebar.tsx.
export const SIDEBAR_COLLAPSE_BREAKPOINT = 1024;
